import { StorageKeys } from "@/constants/storage";

class LazyStorage {
  key: StorageKeys;
  value: string;
  persist: boolean;
  constructor(key: StorageKeys, persist = true) {
    this.key = key;
    this.persist = persist;
    this.value = "";
  }

  setItem(value: string) {
    this.value = value;

    if (this.persist) {
      return localStorage.setItem(this.key, value);
    }
  }

  getItem() {
    if (this.value) {
      return this.value;
    }

    if (this.persist) {
      const value = localStorage.getItem(this.key);

      this.value = value || "";

      return value;
    }
  }

  removeItem() {
    this.value = "";

    if (this.persist) {
      return localStorage.removeItem(this.key);
    }
  }
}

export const tokenStorage = new LazyStorage(StorageKeys.token);
export const refreshTokenStorage = new LazyStorage(StorageKeys.refreshToken);
export const twilioTokenStorage = new LazyStorage(StorageKeys.twilioToken, false);
export const userIdStorage = new LazyStorage(StorageKeys.userId);
export const localeStorage = new LazyStorage(StorageKeys.locale);
export const isDoctorStorage = new LazyStorage(StorageKeys.isDoctor, false);
